module.exports = __webpack_public_path__ + "img/black.b424547e.png";